<template>
	<div class="container">
		<div class="main_box">
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="title"
			>留言</div>
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="text"
			>
				在这里，您可以在线提交您的问题与需求，我们会尽快与您联系或直接在线回复，如果急需回复，请致电 010-69390623
			</div>
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_1"
			>
				<div class="block_1_el">
					<div class="tit required">您的姓名</div>
					<input v-model="username" placeholder="请留下您的姓名" autocomplete="off" />
				</div>
				<div class="block_1_el">
					<div class="tit required">手机/电话</div>
					<input v-model="userphone" placeholder="请留下您的手机/电话号码" autocomplete="off" />
				</div>
				<div class="block_1_el">
					<div class="tit">联系邮箱</div>
					<input v-model="useremail" placeholder="请留下您的邮箱地址" autocomplete="off" />
				</div>
			</div>
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_2"
			>
				<div class="block_2_el">
					<div class="tit required">留言内容</div>
					<div class="text_box">
						<textarea v-model="usercontent" placeholder="请填写您的留言内容" autocomplete="off"></textarea>
						<div class="btn">
							<div @click="submit">提交</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { submitMsg } from '@/api/public'  //提交留言
import md5 from 'js-md5';
export default {
	components:{
		//
	},
	data() {
		return {
			username: '',
			userphone: '',
			useremail: '',
			usercontent: '',
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击提交
		submit() {
			let that = this;
			if(that.username && that.userphone && that.usercontent) {
				that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
				submitMsg({
					name: that.username,
					mobile: that.userphone,
					email: that.useremail,
					content: that.usercontent,
					language: sessionStorage.getItem('lang'),
					access_token: md5(String(that.username)+String(that.userphone)+String(that.useremail)+'Abiores2024')
				}).then(res => {
					that.$toast.clear();
					that.username = '';
					that.userphone = '';
					that.useremail = '';
					that.usercontent = '';
					that.$toast('提交成功');
				});
			}else {
				that.$toast('请先完善留言信息');
			}
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_2{
		display: flex;
		.required::after{
			content: '*';
			color: #C8000A;
		}
		.block_2_el{
			flex: 1;
			font-size: 18px;
			.text_box{
				margin-top: 20px;
				padding: 60px 40px;
				background-color: #F6F6F6;
				border: 1px solid #B8B8B8;
				.btn{
					margin-top: 20px;
					text-align: right;
					div{
						display: inline-block;
						padding: 20px 72px 15px 72px;
						border-radius: 8px 8px 8px 8px;
						border: 1px solid #C8000A;
						font-size: 18px;
						color: #C8000A;
						line-height: 1.5;
						cursor: pointer;
						user-select: none;
					}
				}
				textarea:focus{
					border-bottom: 1px solid #C8000A;
				}
				textarea{
					width: 100%;
					height: 180px;
					border: none;
					background-color: #F6F6F6;
					border-bottom: 1px solid #B8B8B8;
					color: #C8000A;
					font-size: 18px;
					resize: none;
				}
			}
		}
	}
	.block_1{
		display: flex;
		padding: 30px 0 40px 0;
		.required::after{
			content: '*';
			color: #C8000A;
		}
		.block_1_el:last-child{
			margin-right: 0;
		}
		.block_1_el{
			flex: 1;
			margin-right: 64px;
			font-size: 18px;
			input:focus{
				border: 1px solid #C8000A;
			}
			input{
				width: 100%;
				margin-top: 20px;
				padding: 24px 40px;
				background-color: #F6F6F6;
				border: 1px solid #B8B8B8;
				color: #C8000A;
				font-size: 18px;
			}
		}
	}
	.text{
		padding-top: 15px;
		font-size: 18px;
	}
	.title{
		font-size: 40px;
		font-weight: bold;
	}
}
</style>